import {
  Box,
  InputLabel,
  MenuItem,
  Pagination,
  Paper,
  Select,
} from "@mui/material";
import { TypographyHeading } from "shared/molecules/typography-layout";
import { VendorFilter } from "./filter";
import { FormControl, Stack } from "@mui/material";
import NoDataFound from "shared/molecules/no-data";
import SectionTable from "shared/organisms/tables/table";
import Loader from "pages/build-test/loader";
import { useEffect, useState } from "react";
import { useLazyQuery } from "@apollo/client";
import { GET_VENDORS } from "utils/graphql/services/live-classes/queries";
import entitesClient from "utils/graphql/entitiesClient";
import { table } from "./helper";
import liveClassClientService from "utils/graphql/liveclassClient";
import { utcToIst } from "utils/time-util/utcIstTime";

export default function Vendors() {
  const [searchPayload, setSearchPayload] = useState({});
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const [getVendorsList, { loading, error, data }] = useLazyQuery(GET_VENDORS, {
    client: liveClassClientService,
  });

  useEffect(() => {
    getVendorsList({
      variables: {
        input: {
          limit: limit,
          offset: (page - 1) * limit,
          ...searchPayload,
        },
      },
    });
  }, [page, limit, searchPayload]);

  const vendorsData =
              data?.getVendors?.vendors?.map((item: any) => ({
                  ...item,
                  createdAt: utcToIst(item.createdAt),
                  updatedAt: utcToIst(item.updatedAt),
              })) || [];

  return (
    <>
      <TypographyHeading sx={{ mb: 2, mt: 3, fontSize: "25px" }}>
        Vendors{" "}
      </TypographyHeading>

      <VendorFilter
        setSearchPayload={setSearchPayload}
        setPage={setPage}
      />
      <Paper elevation={2} sx={{ mt: 3, p: 2 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
          <FormControl size="small" sx={{ width: 140 }}>
            <InputLabel>Show Entries</InputLabel>
            <Select
              value={limit}
              label="Show Entries"
              onChange={(e) => {
                setLimit(Number(e.target.value));
                setPage(1); // reset to first page
              }}
            >
              <MenuItem value={5}>5</MenuItem>
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
              <MenuItem value={500}>500</MenuItem>
            </Select>
          </FormControl>
        </Box>

        <div>
          {loading && <Loader />}
          {!loading && data?.getVendors?.vendors?.length > 0 ? (
            <SectionTable
              data={vendorsData || []}
              table={table}
              id="id"
              name="id"
              rowsPerPageCount={limit}
              style="false"
              totalRecords={data?.getVendors?.totalCount || 0}
              paginationSegment="false"
              viewSecondaryData="false"
            />
          ) : (
            <div>{!loading && <NoDataFound message="No Data Found" />}</div>
          )}
        </div>

        <Box sx={{ marginTop: "20px" }}>
          <Stack
            direction="row"
            spacing={2}
            justifyContent="center"
            alignItems="center"
          >
            <Pagination
              count={Math.ceil(data?.getVendors?.totalCount / limit) || 1}
              page={page}
              onChange={(e, value) => setPage(value)}
              color="primary"
              size="medium"
            />
          </Stack>
        </Box>
      </Paper>
    </>
  );
}
